<div
  class="if-radio-group-wrapper"
  [class.if-radio-group-wrapper--cards]="layout() === 'cards'"
  role="radiogroup"
  [attr.aria-label]="ariaLabel()">
  @for (option of options(); track option.value; let i = $index) {
    @if (layout() === 'cards') {
      <label class="if-radio-card" [class.if-radio-card--checked]="internalValue === option.value" [class.if-radio-card--disabled]="isOptionDisabled(option)">
        <input
          type="radio"
          class="if-radio"
          [name]="name()"
          [value]="option.value"
          [checked]="internalValue === option.value"
          [disabled]="isOptionDisabled(option)"
          [attr.aria-labelledby]="partId('label', i)"
          [attr.aria-describedby]="option.description ? partId('desc', i) : null"
          (change)="onRadioChange($event)"
          (blur)="onBlur()" />
        <span class="if-radio-custom" aria-hidden="true"></span>
        <span class="if-radio-card-text">
          @if (option.icon) {
            <span class="if-radio-card-icon" aria-hidden="true" [innerHTML]="option.icon | safeHtml"></span>
          }
          <span class="if-radio-text" [id]="partId('label', i)">{{ option.label }}</span>
          @if (option.description) {
            <span class="if-radio-description" [id]="partId('desc', i)">{{ option.description }}</span>
          }
        </span>
      </label>
    } @else {
      <label class="if-radio-label">
        <input
          type="radio"
          class="if-radio"
          [name]="name()"
          [value]="option.value"
          [checked]="internalValue === option.value"
          [disabled]="isOptionDisabled(option)"
          (change)="onRadioChange($event)"
          (blur)="onBlur()" />
        <span class="if-radio-custom"></span>
        <span class="if-radio-text">{{ option.label }}</span>
      </label>
    }
  }
</div>
